function SvgStorage(props) {
  return (
    <svg viewBox="0 0 23 31" width="1em" height="1em" {...props}>
      <g>
        <path d="M20.445.19H2.359C1.062.19 0 1.216 0 2.47v26.045c0 1.253 1.062 2.28 2.359 2.28h18.086c1.297 0 2.359-1.027 2.359-2.28V2.47c0-1.254-1.062-2.28-2.36-2.28m0 1.425c.48 0 .885.391.885.855v26.045c0 .463-.405.854-.884.854H2.359c-.48 0-.885-.391-.885-.854V2.47c0-.464.406-.855.885-.855h18.086" />
        <path d="M4.287 14.462a.725.725 0 01-.737-.713V5.151c0-.65.544-1.176 1.216-1.176h13.271c.672 0 1.217.527 1.217 1.176v8.44c0 .393-.33.712-.737.712a.725.725 0 01-.737-.712V5.4H5.024v8.35c0 .393-.33.712-.737.712m0 12.093a.725.725 0 01-.737-.712v-8.598c0-.65.544-1.176 1.216-1.176h13.271c.672 0 1.217.526 1.217 1.176v8.598c0 .393-.33.712-.737.712a.725.725 0 01-.737-.712v-8.35H5.024v8.35c0 .393-.33.712-.737.712" />
        <path d="M12.822 9.04h-2.84c-.49 0-.886-.384-.886-.856v-1.66h1.474v1.09h1.663v-1.09h1.475v1.66c0 .472-.397.856-.886.856m-.066 12.477h-2.708c-.526 0-.952-.412-.952-.92v-1.595h1.474v1.09h1.663v-1.09h1.475v1.595c0 .508-.426.92-.952.92" />
      </g>
    </svg>
  );
}

export default SvgStorage;
